/* eslint-disable */
import React, { useEffect, useState } from "react";
import RenderHome from "../home/RenderHome";
import { useDispatch, useSelector } from "react-redux";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../../service/axios/axios";
import { useHistory } from "react-router-dom";

const SETTLEMENT_TYPES = [
  { value: "loan", label: "Loans" },
  { value: "mart", label: "UPNMG Mart" },
];

function RequestSettlement() {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state?.auth);
  const user = auth?.user;

  const [formData, setFormData] = useState({
    settlement_type: "loan",
    email: "",
    phone: "",
    id_card: "",
  });
  const [formError, setFormError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [hasPending, setHasPending] = useState(false);
  const [cooldownDaysLeft, setCooldownDaysLeft] = useState(0);
  const [checkingPending, setCheckingPending] = useState(true);

  useEffect(() => {
    dispatch(GetUserProfile());
    axiosInstance
      .get("/settlement/my-settlements")
      .then((res) => {
        const settlements = res.data || [];
        const pending = settlements.some((s) => s.status === "pending");
        setHasPending(pending);

        if (!pending) {
          const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;
          const lastProcessed = settlements
            .filter((s) => s.status === "processed")
            .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0];
          if (lastProcessed) {
            const elapsed = Date.now() - new Date(lastProcessed.updated_at).getTime();
            if (elapsed < TWO_WEEKS_MS) {
              const daysLeft = Math.ceil((TWO_WEEKS_MS - elapsed) / (24 * 60 * 60 * 1000));
              setCooldownDaysLeft(daysLeft);
            }
          }
        }
      })
      .catch(() => {})
      .finally(() => setCheckingPending(false));
  }, []);

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        email: user.email || "",
        phone: user.phone_number || "",
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormError({ ...formError, [e.target.name]: "" });
  };

  const validate = () => {
    const err = {};
    if (!formData.settlement_type) err.settlement_type = "Please select a settlement type";
    if (!formData.email) err.email = "Email is required";
    if (!formData.phone) err.phone = "Phone number is required";
    if (!formData.id_card) err.id_card = "Identification card number is required";
    setFormError(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsLoading(true);
    try {
      await axiosInstance.post("/settlement/request", {
        email: formData.email,
        phone: formData.phone,
        id_card: formData.id_card,
        settlement_type: formData.settlement_type,
      });
      toast.success("Settlement request submitted successfully!");
      setTimeout(() => history.push("/my-settlement-quotation"), 1500);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to submit. Try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const selectedTypeLabel =
    SETTLEMENT_TYPES.find((t) => t.value === formData.settlement_type)?.label || "";

  const isBlocked = isLoading || hasPending || checkingPending || cooldownDaysLeft > 0;

  return (
    <RenderHome>
      <ToastContainer />
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "24px 16px" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "#2d6a4f",
              padding: "20px 28px",
              color: "#fff",
            }}
          >
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
              Request Settlement Quotation
            </h2>
            <p style={{ margin: "6px 0 0", fontSize: 13, opacity: 0.85 }}>
              Select your settlement type and fill in the details below to
              request an outright settlement quote.
            </p>
          </div>

          {/* Pending request notice */}
          {!checkingPending && hasPending && (
            <div
              style={{
                margin: "20px 28px 0",
                padding: "14px 16px",
                background: "#fff8e1",
                border: "1px solid #f9a825",
                borderRadius: 8,
                color: "#7a5c00",
                fontSize: 14,
              }}
            >
              <strong>You have a pending settlement request.</strong> You cannot
              submit a new request until your current one has been processed and
              the quotation is sent to you.{" "}
              <span
                style={{ color: "#2d6a4f", cursor: "pointer", fontWeight: 600 }}
                onClick={() => history.push("/my-settlement-quotation")}
              >
                View your requests &rarr;
              </span>
            </div>
          )}

          {/* 2-week cooldown notice */}
          {!checkingPending && !hasPending && cooldownDaysLeft > 0 && (
            <div
              style={{
                margin: "20px 28px 0",
                padding: "14px 16px",
                background: "#fce4ec",
                border: "1px solid #e57373",
                borderRadius: 8,
                color: "#b71c1c",
                fontSize: 14,
              }}
            >
              <strong>Settlement request not available.</strong> Your last
              settlement was recently processed. You can request a new
              settlement in{" "}
              <strong>
                {cooldownDaysLeft} day{cooldownDaysLeft === 1 ? "" : "s"}
              </strong>
              .{" "}
              <span
                style={{ color: "#2d6a4f", cursor: "pointer", fontWeight: 600 }}
                onClick={() => history.push("/my-settlement-quotation")}
              >
                View your settlements &rarr;
              </span>
            </div>
          )}

          <div style={{ padding: "24px 28px 0" }}>
            {/* Staff ID (auto-filled, read-only) */}
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Staff ID</label>
              <input
                style={{ ...inputStyle, background: "#f5f5f5", color: "#666" }}
                value={user?.staff_id || ""}
                readOnly
              />
            </div>

            <form onSubmit={handleSubmit}>
              {/* Settlement Type */}
              <div style={{ marginBottom: 20 }}>
                <label style={labelStyle}>Settlement Type *</label>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  {SETTLEMENT_TYPES.map(({ value, label }) => {
                    const active = formData.settlement_type === value;
                    return (
                      <label
                        key={value}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "10px 20px",
                          border: `2px solid ${active ? "#2d6a4f" : "#ddd"}`,
                          borderRadius: 8,
                          cursor: isBlocked ? "not-allowed" : "pointer",
                          background: active ? "#e8f5e9" : "#fafafa",
                          color: active ? "#2d6a4f" : "#555",
                          fontWeight: active ? 700 : 500,
                          fontSize: 14,
                          transition: "all 0.15s",
                          userSelect: "none",
                          opacity: isBlocked ? 0.65 : 1,
                        }}
                      >
                        <input
                          type="radio"
                          name="settlement_type"
                          value={value}
                          checked={active}
                          onChange={handleChange}
                          disabled={isBlocked}
                          style={{ display: "none" }}
                        />
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            borderRadius: "50%",
                            border: `2px solid ${active ? "#2d6a4f" : "#bbb"}`,
                            background: active ? "#2d6a4f" : "#fff",
                            display: "inline-block",
                            flexShrink: 0,
                            boxSizing: "border-box",
                            position: "relative",
                          }}
                        >
                          {active && (
                            <span
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%,-50%)",
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                background: "#fff",
                                display: "block",
                              }}
                            />
                          )}
                        </span>
                        {label}
                      </label>
                    );
                  })}
                </div>
                {formError.settlement_type && (
                  <span style={errorStyle}>{formError.settlement_type}</span>
                )}
              </div>

              {/* Contextual hint */}
              {formData.settlement_type === "mart" && (
                <div
                  style={{
                    marginBottom: 16,
                    padding: "10px 14px",
                    background: "#f1f8e9",
                    border: "1px solid #aed581",
                    borderRadius: 7,
                    fontSize: 13,
                    color: "#33691e",
                  }}
                >
                  <strong>Mart Settlement:</strong> Payment must be made into
                  the UPNMG MART account. Bank details will be included in
                  your quotation.
                </div>
              )}

              {/* Email */}
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>Email Address *</label>
                <input
                  style={inputStyle}
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
                {formError.email && (
                  <span style={errorStyle}>{formError.email}</span>
                )}
              </div>

              {/* Phone */}
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>Phone Number *</label>
                <input
                  style={inputStyle}
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                />
                {formError.phone && (
                  <span style={errorStyle}>{formError.phone}</span>
                )}
              </div>

              {/* ID Card */}
              <div style={{ marginBottom: 24 }}>
                <label style={labelStyle}>Identification Card Number *</label>
                <input
                  style={inputStyle}
                  type="text"
                  name="id_card"
                  value={formData.id_card}
                  onChange={handleChange}
                  placeholder="GHA-12xxxxxxxxx-10"
                />
                {formError.id_card && (
                  <span style={errorStyle}>{formError.id_card}</span>
                )}
              </div>

              <button
                type="submit"
                disabled={isBlocked}
                style={{
                  width: "100%",
                  padding: "13px",
                  background: isBlocked ? "#aaa" : "#2d6a4f",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: isBlocked ? "not-allowed" : "pointer",
                  marginBottom: 24,
                }}
              >
                {isLoading
                  ? "Submitting..."
                  : hasPending
                  ? "Request Pending — Awaiting Processing"
                  : cooldownDaysLeft > 0
                  ? `Available in ${cooldownDaysLeft} day${cooldownDaysLeft === 1 ? "" : "s"}`
                  : `Request ${selectedTypeLabel} Settlement`}
              </button>
            </form>
          </div>
        </div>
      </div>
    </RenderHome>
  );
}

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#333",
  marginBottom: 6,
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #ddd",
  borderRadius: 6,
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
};

const errorStyle = {
  color: "#e53935",
  fontSize: 12,
  marginTop: 4,
  display: "block",
};

export default RequestSettlement;
